import React, { memo } from 'react'
import './index.scss'
import { useTranslation } from 'react-i18next'
import { getAppDisplayName, isZivano } from '@/utils/appBrand'

interface RuleProps {
    activityThresholdValue: number
}

function index(props: RuleProps) {
    const { t } = useTranslation()
    const count = isZivano() ? 3 : 4
    return (
        <div className='cmp-rule'>
            {new Array(count).fill(0).map((_, i) =>
                <span key={i}>{t(`AgencyHonor.Rule.Rule${i}`, { APP: getAppDisplayName(), num: props.activityThresholdValue })}</span>
            )}
        </div>
    )
}

export default memo(index)